import { render } from "./EventsLayout.vue?vue&type=template&id=737ec97e&lang=pug"
import script from "./EventsLayout.vue?vue&type=script&lang=js"
export * from "./EventsLayout.vue?vue&type=script&lang=js"

import exportComponent from "/builds/mfar.technology/events/events-platform/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__